document.addEventListener("DOMContentLoaded", function () {
  function showSuccessBar() {
    // Évite les doublons
    if (document.getElementById("wl-success-bar")) return;
    const bar = document.createElement("div");
    bar.id = "wl-success-bar";
    bar.innerHTML = `
  <span class="wl-text">
    ${
      document.documentElement.lang === "en"
        ? "Product added successfully"
        : document.documentElement.lang === "ar"
        ? "تم إضافة المنتج بنجاح"
        : "Produit ajouté avec succès"
    }
  </span>
  <button class="wl-close">&times;</button>
`;
    document.body.appendChild(bar);
    // Close on click
    bar.querySelector(".wl-close").addEventListener("click", () => {
      bar.classList.remove("show");
      setTimeout(() => bar.remove(), 300);
    });
    // Auto-hide
    setTimeout(() => {
      if (document.getElementById("wl-success-bar")) {
        bar.classList.remove("show");
        setTimeout(() => bar.remove(), 300);
      }
    }, 5000);
    // Show animation
    setTimeout(() => bar.classList.add("show"), 50);
  }
  function setupATC(button) {
    if (!button || button.dataset.listenerAdded === "true") return;
    const form = button.closest("form");
    if (!form) return;
    button.dataset.listenerAdded = "true";
    button.addEventListener("click", async function (e) {
      e.preventDefault();
      // Si déjà ajouté → redirection au panier
      if (button.dataset.added === "true") {
        window.location.href = "{{ routes.cart_url }}";
        return;
      }
      const formData = new FormData(form);
      try {
        await fetch("/cart/add.js", {
          method: "POST",
          body: formData,
          headers: { "Accept": "application/json" }
        });
        // Mise à jour compteur
        const cartCountElem = document.querySelector(".header__cart-count-number");
        if (cartCountElem) {
          const cart = await fetch("/cart.js").then(r => r.json());
          cartCountElem.textContent = cart.item_count;
        }
        // Traduction du bouton
        const lang = document.documentElement.lang;
        let txt = "Voir Panier";
        if (lang === "en") txt = "View Cart";
        if (lang === "ar") txt = "عرض السلة";
        button.textContent = txt;
        button.dataset.added = "true";
        // Animation du bouton
        button.classList.add("added-to-cart");
        setTimeout(() => button.classList.remove("added-to-cart"), 800);
        showSuccessBar();
      } catch (err) {
        console.error("Erreur ATC:", err);
      }
    });
  }
  const observer = setInterval(() => {
    const productBtn = document.querySelector(".add-to-cart-sticky button");
    if (productBtn) setupATC(productBtn);

    const drawerBtn = document.querySelector(".quick-add__footer button");
    if (drawerBtn) setupATC(drawerBtn);
  }, 300);

  setTimeout(() => clearInterval(observer), 10000);
});
document.addEventListener("change", function (e) {
  if (e.target.name === "id") { 
    const button = document.querySelector(".add-to-cart-sticky button");
    if (button) {
      // Reset
      button.dataset.added = "false";
      // Remettre texte selon langue
      const lang = document.documentElement.lang;
      let txt = "Ajouter au panier";
      if (lang === "en") txt = "Add to cart";
      if (lang === "ar") txt = "أضف إلى السلة";

      button.textContent = txt;
    }
  }
});